<template>
	<el-dialog title="工艺参数详情" :visible.sync="visible" :before-close="beforClose" width="50%" style="min-width:400px;">
		<el-table v-loading="tableLoading" :data="data" size="small" height="400px">
			<el-table-column prop="name" label="工艺参数名"></el-table-column>
			<el-table-column prop="max" label="最大值" width="80"></el-table-column>
			<el-table-column prop="min" label="最小值" width="80"></el-table-column>
			<el-table-column prop="avg" label="平均值" width="80"></el-table-column>
			<el-table-column prop="unit" label="单位" width="80"></el-table-column>
		</el-table>
	</el-dialog>
</template>

<script>
	import * as teachGroupRequest from '@/network/requests/techGroup'
	export default {
		props: {
			show: {
				type: Boolean,
			},
			teachGroupId: {
				type: String,
			},
		},
		data() {
			return {
				data: [],
				pageCount: 0,
				visible: false,
				tableLoading: false,
			}
		},
		watch: {
			/**
			 * 监听显示状态。
			 */
			show(val) {
				this.visible = val
			},
			/**
			 * 切换工艺参数组。
			 */
			teachGroupId(val) {
				console.log('tech_group_id', val)
				this.tableLoading = true
				if (val) {
					this.getTeachGroupsDetail()
				} else {
					this.data = []
					this.tableLoading = false
				}
			},
		},
		methods: {
			/**
			 * 获取参数组详情。
			 */
			getTeachGroupsDetail() {
				if (!this.teachGroupId) {
					this.tableLoading = false
					return
				}
				teachGroupRequest
					.queryTechGroupDetailById(this.teachGroupId)
					.then(res => {
						this.data = res
					})
					.finally(() => {
						this.tableLoading = false
					})
			},
			/**
			 * 关闭
			 */
			beforClose(done) {
				this.$emit('close')
				done()
			},
		},
		created() {
			this.data = []
		},
	}
</script>

<style></style>
